import { createContext, useContext } from 'react';
/**
 * Context for providing the shared System API WebSocket client.
 * The WsClient is created at bootstrap (via connectSystemApi) and
 * provided at the app root so any component can subscribe to topics.
 */
export const SystemApiWsContext = createContext(null);
/**
 * Hook to access the shared System API WebSocket client.
 * Returns null if the client hasn't been initialized yet.
 */
export const useSystemApiWsClient = () => {
    return useContext(SystemApiWsContext);
};
/**
 * Provider component for the System API WebSocket client.
 * Wrap your app with this provider and pass in the WsClient instance.
 */
export const SystemApiWsProvider = SystemApiWsContext.Provider;
//# sourceMappingURL=SystemApiWsContext.js.map